import { action, select } from 'satcheljs/lib/legacy';
import InboxRuleRequestStatus from '../store/schema/InboxRuleRequestStatus';
import InboxRuleStore from '../store/schema/InboxRuleStore';
import inboxRuleStore from '../store/store';

export interface ShowHideInboxRuleDialogState {
    inboxRuleStore: InboxRuleStore;
}

/**
 * Show or hide the inbox rule dialog
 * @param shouldShow whether this is to show the inbox rule dialog
 * @param state the state which contains the inbox rule store
 */
export default action('showHideInboxRuleDialog')(
    select({
        inboxRuleStore: () => inboxRuleStore,
    })(function showHideInboxRuleDialog(shouldShow: boolean, state?: ShowHideInboxRuleDialogState) {
        state.inboxRuleStore.isInboxRuleDialogShown = shouldShow;

        if (!shouldShow) {
            // Clear the create rule view state if hiding the dialog
            state.inboxRuleStore.inboxRuleRequestStatus = InboxRuleRequestStatus.NotInitiated;
            state.inboxRuleStore.selectedFolderId = null;
        }
    })
);
